import React from 'react';
import { appRoutes } from 'routeConfig';
import Minimal from 'layouts/Minimal/Minimal';
import NotFound from 'views/NotFound/NotFound';
import { Redirect, Switch } from 'react-router-dom';
import SemPermissao from 'views/Errors/SemPermissao';
import ProtectedRouteWithLayout from 'components/ProtectedRouteWithLayout';

/* Chamador principal de rotas */
const Routes = () => {
  return (
    <Switch>
      <Redirect
        exact
        from="/"
        to="/gerencial"
      />

      {appRoutes.map((route) => (
        <ProtectedRouteWithLayout
          key={route.path}
          exact={route.exact}
          path={route.path}
          layout={route.layout}
          component={route.component}
          moduleCode={route.moduleCode}
          requiredPerm={route.requiredPerm}
          isPublic={route.isPublic}
          authType={route.authType}
          redirectTo={route.redirectTo}
        />
      ))}

      <ProtectedRouteWithLayout
        exact
        path="/sem-permissao"
        layout={Minimal}
        component={SemPermissao}
        isPublic
        authType="public"
      />

      <ProtectedRouteWithLayout
        exact
        path="/not-found"
        layout={Minimal}
        component={NotFound}
        isPublic
        authType="public"
      />

      <Redirect to="/not-found" />
    </Switch>
  );
};

export default Routes;